// Default accent colors for planning event system stages.
// Matches n-* scale in app/javascript/dashboard/assets/scss/_next-colors.scss
export const DEFAULT_STAGE_COLORS = {
  draft: '#8B8D98', // n-slate-9
  inquiry: '#2781F6', // n-blue-9
  confirmed: '#5B5BD6', // n-iris-9
  completed: '#12A594', // n-teal-9
  lost: '#E54666', // n-ruby-9
  archived: '#80838D', // n-slate-10
};

export const EVENT_STAGES = [
  'draft',
  'inquiry',
  'confirmed',
  'completed',
  'lost',
  'archived',
];

export const getDefaultStageColor = stage =>
  DEFAULT_STAGE_COLORS[stage] || DEFAULT_STAGE_COLORS.draft;

export const resolveEventAccentColor = event => {
  if (event?.accent_color) return event.accent_color;
  if (event?.status_color) return event.status_color;
  return getDefaultStageColor(event?.system_stage);
};

export const resolveAllocationAccentColor = (allocation, event) => {
  if (event?.accent_color) return event.accent_color;
  if (event?.status_color) return event.status_color;
  if (allocation?.accent_color) return allocation.accent_color;
  if (allocation?.status_color) return allocation.status_color;
  const stage = event?.system_stage || allocation?.metadata?.event_status;
  return stage ? getDefaultStageColor(stage) : null;
};

export const resolveStatusOptionColor = option =>
  option?.resolved_color || getDefaultStageColor(option?.system_stage);

export const useEventStageColors = () => {
  return {
    stages: EVENT_STAGES,
    defaultStageColors: DEFAULT_STAGE_COLORS,
    getDefaultStageColor,
    resolveEventAccentColor,
    resolveAllocationAccentColor,
    resolveStatusOptionColor,
  };
};
